import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// this helper unwraps to the `data` payload for callers.

export async function getMyGymAnalytics(params = {}) {
  const res = await api.get('/gyms/me/analytics', { params });
  return res.data.data;
}
